import { useEffect, useState } from "react";
import { api } from "../api/client";

interface AlertRow {
  id: string;
  symbol: string;
  kind: string;
  condition: Record<string, unknown>;
  status: string;
  created_at: number;
  triggered_at: number | null;
}

export function Alerts() {
  const [items, setItems] = useState<AlertRow[]>([]);
  const [symbol, setSymbol] = useState("BTCUSDT");
  const [kind, setKind] = useState<"price_above" | "price_below">("price_above");
  const [value, setValue] = useState("");

  async function load() {
    const data = await api<AlertRow[]>("/v1/alerts");
    setItems(data);
  }
  useEffect(() => {
    load().catch(() => {});
  }, []);

  async function create() {
    if (!value) return;
    await api("/v1/alerts", {
      method: "POST",
      body: { symbol, kind, condition: { value: parseFloat(value) } },
    });
    setValue("");
    load();
  }

  async function remove(id: string) {
    await api(`/v1/alerts/${id}`, { method: "DELETE" });
    load();
  }

  return (
    <div className="page">
      <h1>Alerts</h1>
      <div className="form-row">
        <input value={symbol} onChange={(e) => setSymbol(e.target.value.toUpperCase())} />
        <select value={kind} onChange={(e) => setKind(e.target.value as typeof kind)}>
          <option value="price_above">Price above</option>
          <option value="price_below">Price below</option>
        </select>
        <input
          placeholder="Value"
          value={value}
          inputMode="decimal"
          onChange={(e) => setValue(e.target.value)}
        />
        <button type="button" className="btn btn-primary" onClick={create}>
          Add
        </button>
      </div>
      <table className="markets-table">
        <thead>
          <tr>
            <th>Symbol</th>
            <th>Kind</th>
            <th>Condition</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {items.map((a) => (
            <tr key={a.id}>
              <td>{a.symbol}</td>
              <td>{a.kind}</td>
              <td className="muted">{JSON.stringify(a.condition)}</td>
              <td>{a.status}</td>
              <td>
                <button type="button" className="btn btn-ghost btn-sm" onClick={() => remove(a.id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {items.length === 0 && (
            <tr>
              <td colSpan={5} className="muted">
                No alerts.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
